// extracted by mini-css-extract-plugin
module.exports = {"Loader":"Spinner_Loader__1twK-","load8":"Spinner_load8__36vjM","label":"Spinner_label__3hWnZ","center":"Spinner_center__2vn5M"};